import React from 'react';
import Highlight from './Highlight';
import AutoParts from '../assets/images/AutoParts.png';
import Button from './Button';
import ShadowContainer from './ShadowContainer';

const Offer = () => {
  return (
    <div style={styles.wrapper}>
      <div style={styles.textWrapper}>
        <Highlight width={750} height={461} />
        <div style={styles.textBox}>
          <h3 style={styles.heading}>
            Smart Part–Pouzdano rešenje za nabavku auto delova
          </h3>
          <p style={styles.text}>
            Smart Part je inovativna platforma koja povezuje kupce novih i polovnih auto delova sa proverenim prodavcima, omogućavajući vam da birate najpovoljniju ponudu. Naš tim stoji iza vas sa više od deceniju iskustva u industriji auto delova i širokom mrežom kontakata, što garantuje kvalitet i pouzdanost svake transakcije. Model poslovanja Smart Part-a zasniva se na sistemu obrnute aukcije – vi postavite svoju potražnju, a prodavci vam dostave konkurentne ponude, pružajući vam slobodu izbora uz optimalnu cenu.
          </p>
          <Button
            width={420}
            height={72}
            borderColor="yellow"
            backgroundColor="#d3e205"
            text="Zatraži ponudu za deo"
          />
        </div>
      </div>
      <ShadowContainer
        Image={AutoParts}
        width={960}
        height={793}
        imageStyle={styles.shadowContainer}
      />
    </div>
  );
};

export default Offer;

const styles = {
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgb(23, 23, 24)',
    padding: 40,
    gap: 40,
    flexWrap: 'wrap',
    position: 'relative',
    marginBottom: '100px'

  },
  textWrapper: {
    position: 'relative',
    width: 550,
    height: 461,
    zIndex: 3,
  },
  textBox: {
    position: 'relative',
    backgroundImage: 'linear-gradient(232deg, rgba(153, 153, 153, 0.2) 0%, rgba(255, 255, 255, 0.2) 100%)',
    padding: 20,
    borderRadius: 12,
    width: 750,
    height: 461,
    zIndex: 2,
    backdropFilter: 'blur(6px)',
  },
  heading: {
    fontSize: '48px',
    fontWeight: 700,
    backgroundImage: 'linear-gradient(235.42deg, #EEFF00 0%, #B6BB6C 100%)',
    backgroundClip: 'text',
    color: 'transparent',
    marginBottom: 16,
    lineHeight: '48px',
  },
  text: {
    fontSize: '18px',
    color: '#ffffff',
    lineHeight: '28px',
    marginBottom: 24,
  },
  shadowContainer: {
    objectPosition: 'top'
  }

};
